// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__sV7-k","Cell":"EmployeeTable_Cell__4opuv","Paper":"EmployeeTable_Paper__rlB0M"};